import { CommandType } from '../../../i4b/enums/command-type.enum';
import { I4BCellType } from '../configurations';
import { I4bCellConcept } from '../enums';
import { HeaderType } from '../models';
import { I4BButtonColumn } from './i4b-button.column';

export class KercomDeviceButtonColumn extends I4BButtonColumn {
  constructor() {
    super(
      {
        type: HeaderType.CALL_TO_ACTION,
        displayName: 'BUTTON',
        icon: ''
      },
      {
        concept: I4bCellConcept.DEVICES,
        isConfigurable: false,
        isDefault: true,
        isLink: false,
        position: '',
        sortProperty: '',
        width: 10,
        id: 'button',
        cell: {
          type: I4BCellType.CALL_TO_ACTION,
          bulkActions: [
            {
              order: 1,
              key: 'bulkEditDevices',
              label: 'DEVICES.INFO_FORM_POPUP.EDIT_DEVICES',
              enableConditions: [],
              disableConditions: [],
              visibleConditions: [[{ key: 'canUpdateDevice', value: true }]]
            },
            {
              order: 2,
              key: 'bulkEditDeviceFiles',
              label: 'DEVICES.FILES_POPUP.TITLE',
              enableConditions: [],
              disableConditions: [],
              visibleConditions: [[{ key: 'canUpdateDevice', value: true }]]
            },
            {
              order: 3,
              key: `bulk_${CommandType.REFRESH}_command`,
              label: `DEVICES.DETAIL_DEVICE_CARD.COMMANDS.${CommandType.REFRESH.toUpperCase()}`,
              enableConditions: [],
              disableConditions: [],
              visibleConditions: [[{ key: 'canReadDevice', value: true }]],
              divider: true
            },
            {
              order: 4,
              key: `bulk_${CommandType.SELFCONF}_command`,
              label: `DEVICES.DETAIL_DEVICE_CARD.COMMANDS.${CommandType.SELFCONF.toUpperCase()}`,
              enableConditions: [],
              disableConditions: [],
              visibleConditions: [[{ key: 'canReadDevice', value: true }]]
            },
            {
              order: 5,
              divider: true,
              key: 'bulk_reset_command',
              label: 'DEVICES.DETAIL_DEVICE_CARD.COMMANDS.RESET',
              enableConditions: [],
              disableConditions: [],
              visibleConditions: [[{ key: 'canReadDevice', value: true }]]
            },
            {
              order: 6,
              key: 'bulk_save_local_config_command',
              label: 'DEVICES.DETAIL_DEVICE_CARD.COMMANDS.SAVE_LOCAL_CONFIG',
              enableConditions: [],
              disableConditions: [],
              visibleConditions: [[{ key: 'canReadDevice', value: true }]]
            },
            {
              order: 7,
              key: 'bulk_backup_local_config_command',
              label: 'DEVICES.DETAIL_DEVICE_CARD.COMMANDS.BACKUP_LOCAL_CONFIG',
              enableConditions: [],
              disableConditions: [],
              visibleConditions: [[{ key: 'canReadDevice', value: true }]]
            }
          ],
          singleActions: [
            {
              order: 2,
              key: 'editDeviceFiles',
              label: 'DEVICES.FILES_POPUP.TITLE',
              enableConditions: [],
              disableConditions: [],
              visibleConditions: [[{ key: 'canUpdateDevice', value: true }]]
            },
            {
              order: 3,
              key: `${CommandType.REFRESH}_command`,
              label: `DEVICES.DETAIL_DEVICE_CARD.COMMANDS.${CommandType.REFRESH.toUpperCase()}`,
              enableConditions: [],
              disableConditions: [],
              visibleConditions: [[{ key: 'canReadDevice', value: true }]]
            },
            {
              order: 4,
              key: `${CommandType.SELFCONF}_command`,
              label: `DEVICES.DETAIL_DEVICE_CARD.COMMANDS.${CommandType.SELFCONF.toUpperCase()}`,
              enableConditions: [],
              disableConditions: [],
              visibleConditions: [[{ key: 'canReadDevice', value: true }]]
            },
            {
              order: 5,
              key: `${CommandType.UNBLOCK}_command`,
              label: `DEVICES.DETAIL_DEVICE_CARD.COMMANDS.${CommandType.UNBLOCK.toUpperCase()}`,
              enableConditions: [],
              disableConditions: [],
              visibleConditions: [[{ key: 'canReadDevice', value: true }]]
            },
            {
              order: 6,
              key: `${CommandType.GET_ALARM}_command`,
              label: `DEVICES.DETAIL_DEVICE_CARD.COMMANDS.${CommandType.GET_ALARM.toUpperCase()}`,
              enableConditions: [],
              disableConditions: [],
              visibleConditions: [[{ key: 'canReadDevice', value: true }]]
            }
          ],
          visibleConditions: [],
          enableConditions: []
        }
      },
      { order: 1000 }
    );
  }
}
